import { render } from "./ValidarDocumento.vue?vue&type=template&id=686c887a&scoped=true"
import script from "./ValidarDocumento.vue?vue&type=script&lang=js"
export * from "./ValidarDocumento.vue?vue&type=script&lang=js"

import "./ValidarDocumento.vue?vue&type=style&index=0&id=686c887a&lang=scss&scoped=true"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686c887a"]])

export default __exports__